import _startCase from 'lodash/startCase';

export function getDisplayableAssociation(association) {
  const displayable = association.replace(/_/g, ' ');
  return _startCase(displayable.toLowerCase());
}
